import { ScrollArea as CssModulesScrollArea } from '@sunwebgroup/uds-ui/scroll-area'
import { styled } from 'styled-components'

export const Root = Object.assign(
  styled(CssModulesScrollArea.Root)``,
  { displayName: 'ScrollArea.Root' },
)

export const Viewport = Object.assign(
  styled(CssModulesScrollArea.Viewport)``,
  { displayName: 'ScrollArea.Viewport' },
)

export const Scrollbar = Object.assign(
  styled(CssModulesScrollArea.Scrollbar)``,
  { displayName: 'ScrollArea.Scrollbar' },
)

export const Thumb = Object.assign(
  styled(CssModulesScrollArea.Thumb)``,
  { displayName: 'ScrollArea.Thumb' },
)
